/**
 * Created by Dhanya Akhil on 2/02/2017.
 */
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ProfileApi } from './api/profile.api';

interface MenuItem {
  id: number;
  title: string;
  link: string | null;
  parent: number | null;
  menuOrder: number;
  subMenuCount: number | null;
  subMenus: MenuItem[];
}

@Injectable()
export class ProfileService {
  constructor(private profileApi:ProfileApi) {}

  getAuthenticatedMenus(): Observable<MenuItem[]> {
    return this.profileApi.getAuthentecatedMenu().pipe(
      map((response: MenuItem[]) => {
        const riskProfileMenuItem: MenuItem = {
          "id": 20,
          "title": "Risk Profile",
          "link": "riskprofile",
          "parent": null,
          "menuOrder": 9,
          "subMenuCount": 0,
          "subMenus": []
        };

        return [...response, riskProfileMenuItem];
      })
    );
  }
}
